/**
 * Authorization Roles
 */
const authRoles = {
  admin: ["admin"],
  organization: ["admin", "business"],
  user: ["admin", "business", "recipient"],
  onlyGuest: ["guest"],
  anyOne: ["admin", "business", "recipient", "guest"],
};

export default authRoles;
